import Illustration from './Illustration';

interface Props {
  description: string;
  illustration: string;
  title: string;
}

const Empty = ({ description, illustration, title }: Props) => {
  return (
    <div className="r-flex r-flex-col r-items-center r-justify-center">
      <div className="r-w-full r-flex r-flex-col">
        <div className="r-mb-4">
          <Illustration
            alt={title}
            className="r-object-cover r-block r-m-auto"
            name={illustration}
          />
        </div>
        <div className="r-p-4 r-flex r-flex-col r-justify-center r-items-center">
          <span className="r-inline-block r-text-xl r-font-bold r-text-center">
            {title}
          </span>
          <span className="r-inline-block r-text-md r-text-center r-opacity-80 r-mb-4">
            {description}
          </span>
        </div>
        {/* TO DO: add action button */}
      </div>
    </div>
  );
};

export default Empty;
